import { CheckPicker } from 'rsuite';
import { CustomButton } from '../../../../../components/CustomButton';
import RModal from '../../../../../components/Rsuite/Modal';
import { useCallback, useEffect, useState } from 'react';
import { Field } from '../../styles';
import { Label } from '../../../../../components/Label';
import { CustomInput } from '../../../../../components/CustomInput';
import api from '../../../../../services/api';
import { toastError, toastSuccess } from '../../../../../toasts';

const EditarCadastrarRegrasPromo = ({
  open,
  handleClose,
  rule,
  products,
  promo,
  setRules,
}) => {
  const [productSelected, setProductSelected] = useState([]);
  const [quantity, setQuantity] = useState(1);

  const handleChange = (value) => {
    setProductSelected(value);
  };

  const [saving, setSaving] = useState(false);

  const handleCreate = useCallback(async () => {
    const form = {
      IdPromocao: promo.Id,
      IdsProduto: productSelected,
      Quantidade: quantity,
    };
    const response = await api.post('promocao-regra/criar', form);
    const newProducts = response.data.map((item) => ({
      ...item,
      DescricaoProduto: products.find((x) => x.value === item.IdProduto)?.label,
    }));
    setRules((state) => [...state, ...newProducts]);
    toastSuccess('Regras cadastradas com sucesso.');
  }, [promo.Id, productSelected, quantity, setRules, products]);

  const handleUpdate = useCallback(async () => {
    const form = {
      Quantidade: quantity,
    };
    const response = await api.patch(`promocao-regra/${rule.Id}`, form);
    setRules((state) =>
      state.map((e) => (e.Id !== response.data.Id ? e : { ...e, ...response.data })),
    );
    toastSuccess('Regra alterada com sucesso.');
  }, [quantity, rule?.Id, setRules]);

  const handleSubmit = useCallback(async () => {
    if (!rule && productSelected.length < 1) {
      toastError('Selecione ao menos um produto.');
      return;
    }
    if (+quantity < 1) {
      toastError('Informe uma quantidade válida.');
      return;
    }

    setSaving(true);
    try {
      if (rule) await handleUpdate();
      else await handleCreate();
      handleClose();
    } catch (error) {
      toastError(error?.response?.data?.Msg || 'Não foi possível salvar a regra.');
    } finally {
      setSaving(false);
    }
  }, [rule, productSelected, quantity, handleUpdate, handleCreate, handleClose]);

  useEffect(() => {
    if (rule) {
      setQuantity(rule.Quantidade);
      setProductSelected([rule.IdProduto]);
    }
  }, [open, rule]);

  return (
    <RModal
      open={open}
      onClose={handleClose}
      title={(rule ? 'Editar' : 'Cadastrar') + ' regra'}
      footer={
        <>
          <CustomButton appearance="default" onClick={handleClose}>
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleSubmit} loading={saving} disabled={saving}>Salvar</CustomButton>
        </>
      }
    >
      {!rule && (
        <Field>
          <Label>Produtos</Label>
          <CheckPicker
            data={products}
            value={productSelected}
            onChange={handleChange}
            style={{ width: 400 }}
          />
        </Field>
      )}
      <Field>
        <Label>Quantidade</Label>
        <CustomInput
          type="number"
          min={1}
          value={quantity}
          onChange={(e) => {
            if (e > 0) setQuantity(+e);
          }}
        />
      </Field>
    </RModal>
  );
};

export default EditarCadastrarRegrasPromo;
